export const mockUp = {
    '0': {
        remains: 0,
        result: [
            {
            image: "img/photo1.jpg",
            type: "Хоккей",
            data: "07 мая 2023",
            text: "Все пляжники «ФАКЕЛА» — в плей-офф третьего этапа чемпионата России"
            },
            {
                image: "img/photo1.jpg",
                type: "Хоккей",
                data: "07 мая 2023",
                text: "Все пляжники «ФАКЕЛА» — в плей-офф третьего этапа чемпионата России"
            },
            {
                image: "img/photo1.jpg",
                type: "Хоккей",
                data: "07 мая 2023",
                text: "Все пляжники «ФАКЕЛА» — в плей-офф третьего этапа чемпионата России"
            },
            {
                image: "img/photo1.jpg",
                type: "Хоккей",
                data: "07 мая 2023",
                text: "Все пляжники «ФАКЕЛА» — в плей-офф третьего этапа чемпионата России"
            },
            {
                image: "img/photo1.jpg",
                type: "Хоккей",
                data: "07 мая 2023",
                text: "Все пляжники «ФАКЕЛА» — в плей-офф третьего этапа чемпионата России"
            },
            {
                image: "img/photo1.jpg",
                type: "Хоккей",
                data: "07 мая 2023",
                text: "Все пляжники «ФАКЕЛА» — в плей-офф третьего этапа чемпионата России"
            },
            {
                image: "img/photo1.jpg",
                type: "Хоккей",
                data: "07 мая 2023",
                text: "Все пляжники «ФАКЕЛА» — в плей-офф третьего этапа чемпионата России"
            },
            {
                image: "img/photo1.jpg",
                type: "Хоккей",
                data: "07 мая 2023",
                text: "Все пляжники «ФАКЕЛА» — в плей-офф третьего этапа чемпионата России"
            },
            {
                image: "img/photo1.jpg",
                type: "Хоккей",
                data: "07 мая 2023",
                text: "Все пляжники «ФАКЕЛА» — в плей-офф третьего этапа чемпионата России"
            }
        ]
    },
    '1': {
        remains: 0,
        result: [{
            image: "img/planirovka1.png",
            flat_number: "2-комнатная № 7",
            section: "2",
            area: "42.23",
            floor: "16",
            price: "3 050 000"
        },
            {
                image: "img/planirovka1.png",
                flat_number: "2-комнатная № 7",
                section: "2",
                area: "42.23",
                floor: "16",
                price: "3 050 000"
            }
        ]
    },
    '2': {
        remains: 10,
        result: [
            {
                image: "img/planirovka1.png",
                flat_number: "2-комнатная № 7",
                section: "2",
                area: "42.23",
                floor: "16",
                price: "4 050 000"
            },
            {
                image: "img/planirovka1.png",
                flat_number: "2-комнатная № 7",
                section: "2",
                area: "42.23",
                floor: "16",
                price: "3 050 000"
            },
            {
                image: "img/planirovka1.png",
                flat_number: "2-комнатная № 7",
                section: "2",
                area: "42.23",
                floor: "16",
                price: "3 050 000"
            },
            {
                image: "img/planirovka1.png",
                flat_number: "2-комнатная № 7",
                section: "2",
                area: "42.23",
                floor: "16",
                price: "3 050 000"
            },
            {
                image: "img/planirovka1.png",
                flat_number: "2-комнатная № 7",
                section: "2",
                area: "42.23",
                floor: "16",
                price: "3 050 000"
            },
            {
                image: "img/planirovka1.png",
                flat_number: "2-комнатная № 7",
                section: "2",
                area: "42.23",
                floor: "16",
                price: "3 050 000"
            },{
                image: "img/planirovka1.png",
                flat_number: "2-комнатная № 7",
                section: "2",
                area: "42.23",
                floor: "16",
                price: "4 050 000"
            },{
                image: "img/planirovka1.png",
                flat_number: "2-комнатная № 7",
                section: "2",
                area: "42.23",
                floor: "16",
                price: "4 050 000"
            }
        ]
    }
}